/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rv_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type or paste text…`)
};

const es_rv_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escribe o pega texto…`)
};

const de_rv_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text eingeben oder einfügen…`)
};

const nl_rv_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ of plak tekst…`)
};

const fr_rv_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tapez ou collez le texte…`)
};

const it_rv_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digita o incolla testo…`)
};

const pt_br2_rv_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite ou cole o texto…`)
};

const pt_rv_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite ou cole texto…`)
};

const ja_rv_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストを入力またはペーストしてください…`)
};

const zh_rv_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入或粘贴文本…`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rv_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rv_placeholder(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rv_placeholder", locale)
	if (locale === "en") return en_rv_placeholder(inputs)
	if (locale === "es") return es_rv_placeholder(inputs)
	if (locale === "de") return de_rv_placeholder(inputs)
	if (locale === "nl") return nl_rv_placeholder(inputs)
	if (locale === "fr") return fr_rv_placeholder(inputs)
	if (locale === "it") return it_rv_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_rv_placeholder(inputs)
	if (locale === "pt") return pt_rv_placeholder(inputs)
	if (locale === "ja") return ja_rv_placeholder(inputs)
	return zh_rv_placeholder(inputs)
};